export default __webpack_public_path__ + "static/media/day_column.6f27f930.svg";